import React from 'react';
import './detailBoxLargeJob.css';
import { checkOrangeIcon, circleIcon } from '../../../../utils/icons';

const DetailBoxLargeJob = ({ title, data, checkedBenefits }) => {
  
  const normalizeString = (str) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  // Mapping from camelCase keys to display names (matching the data array order)
  const benefitKeyToDisplayName = {
    'seguro': 'Seguro',
    'traslado': 'Traslado',
    'uniforme': 'Uniforme',
    'capacitación': 'Capacitaciones',
    'colación': 'Colación',
    'formación': 'Formación',
    'cumpleañoslibre': 'Cumpleaños libre',
    'conveniosexternos': 'Convenios externos',
    'descuentoscorporativos': 'Descuentos corporativos',
    'contratoscorporativos': 'Contratos corporativos',
    'otras': 'Otras'
  };

  // Ensure checkedBenefits is always an array
  const safeCheckedBenefits = Array.isArray(checkedBenefits) ? checkedBenefits : [];
  
  // Convert benefits to display names
  // Benefits can come as:
  // 1. Numeric indices (e.g., ['0', '1']) - convert using data array
  // 2. CamelCase keys (e.g., ['seguro', 'traslado']) - convert using mapping
  // 3. Display names (e.g., ['Seguro', 'Traslado']) - keep as is
  const normalizedCheckedBenefits = safeCheckedBenefits.map(benefit => {
    // If benefit is a numeric string (index), convert to the actual benefit name from data array
    if (typeof benefit === 'string' && /^\d+$/.test(benefit)) {
      const index = parseInt(benefit);
      return data[index] || benefit; // Return the benefit name at that index
    }
    // If benefit is a camelCase key, convert to display name
    const normalizedKey = normalizeString(benefit);
    if (benefitKeyToDisplayName[normalizedKey]) {
      return benefitKeyToDisplayName[normalizedKey];
    }
    // If it's already a display name or something else, return as is
    return benefit;
  });
  
  return (
    <div className='detail-box-large-job__skills-container'>
      <h3>{title}</h3>
      <ul className="detail-box-large-job__grid-box-container">
        {data.map((value, index) => {
          // Check if this benefit is in the normalized checked benefits
          const isChecked = normalizedCheckedBenefits.some(benefit => 
            normalizeString(benefit) === normalizeString(value)
          );
          
          return (
            <li key={index} className='detail-box-large-job__icon-value-container'>
              {isChecked ? checkOrangeIcon : circleIcon}
              <div className="detail-box-large-job__value-container">
                {value}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DetailBoxLargeJob;


